type KratosPasskey {
  token: String
  display_name: String
  added_at: String
}

type KratosSettingsFlow {
  id: String
  csrf_token: String
  passkey_create_data: String
  passkeys: [KratosPasskey!]
}

type KratosLoginFlow {
  id: String
  csrf_token: String
  passkey_challenge: String
}

type KratosPasskeyLogin {
  email: String
}
